import { render, staticRenderFns } from "./ReportsTabControlling.vue?vue&type=template&id=edc357dc&"
import script from "./ReportsTabControlling.vue?vue&type=script&lang=js&"
export * from "./ReportsTabControlling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports